export enum GooglePlaceType {
  accounting = 'organization',
  airport = 'airport',
  archipelago = 'city',
  amusement_park = 'attractions',
  aquarium = 'attractions',
  art_gallery = 'attractions',
  atm = 'organization',
  bakery = 'organization',
  bank = 'organization',
  bar = 'organization',
  subway_entrance = 'organization',
  beauty_salon = 'organization',
  bicycle_store = 'organization',
  book_store = 'organization',
  bowling_alley = 'organization',
  bus_station = 'busStation',
  cafe = 'organization',
  campground = 'organization',
  car_dealer = 'organization',
  car_rental = 'organization',
  car_repair = 'organization',
  car_wash = 'organization',
  casino = 'organization',
  cemetery = 'organization',
  church = 'organization',
  city_hall = 'attractions',
  clothing_store = 'organization',
  convenience_store = 'organization',
  secondary_school = 'organization',
  tourist_attraction = 'attractions',
  courthouse = 'organization',
  dentist = 'organization',
  department_store = 'organization',
  rapids = 'organization',
  doctor = 'organization',
  electrician = 'organization',
  electronics_store = 'organization',
  embassy = 'organization',
  fire_station = 'organization',
  florist = 'organization',
  funeral_home = 'organization',
  furniture_store = 'organization',
  gas_station = 'organization',
  gym = 'organization',
  hair_care = 'organization',
  hardware_store = 'organization',
  hindu_temple = 'organization',
  home_goods_store = 'organization',
  hospital = 'organization',
  insurance_agency = 'organization',
  jewelry_store = 'organization',
  laundry = 'organization',
  lawyer = 'organization',
  library = 'organization',
  liquor_store = 'organization',
  local_government_office = 'organization',
  locksmith = 'organization',
  light_rail_station = 'railStation',
  lodging = 'hotel',
  meal_delivery = 'organization',
  meal_takeaway = 'organization',
  mosque = 'organization',
  movie_rental = 'organization',
  movie_theater = 'organization',
  moving_company = 'organization',
  museum = 'attractions',
  night_club = 'organization',
  painter = 'organization',
  park = 'attractions',
  parking = 'organization',
  pet_store = 'organization',
  pharmacy = 'organization',
  physiotherapist = 'organization',
  plumber = 'organization',
  police = 'organization',
  post_office = 'organization',
  real_estate_agency = 'organization',
  restaurant = 'organization',
  roofing_contractor = 'organization',
  rv_park = 'organization',
  grocery_or_supermarket = 'organization',
  school = 'organization',
  shoe_store = 'organization',
  shopping_mall = 'organization',
  spa = 'organization',
  stadium = 'organization',
  storage = 'organization',
  store = 'organization',
  subway_station = 'subwayStation',
  supermarket = 'organization',
  synagogue = 'organization',
  taxi_stand = 'organization',
  train_station = 'trainStation',
  transit_station = 'transitStation',
  travel_agency = 'organization',
  veterinary_care = 'organization',
  zoo = 'attractions',
  administrative_area_level_1 = 'distrcict',
  administrative_area_level_2 = 'distrcict',
  administrative_area_level_3 = 'distrcict',
  administrative_area_level_4 = 'distrcict',
  administrative_area_level_5 = 'distrcict',
  colloquial_area = 'distrcict',
  country = 'distrcict',
  tertiary = 'distrcict',
  quarter = 'distrcict',
  establishment = 'organization',
  finance = 'organization',
  alcohol = 'organization',
  floor = 'organization',
  food = 'organization',
  general_contractor = 'organization',
  geocode = 'distrcict',
  health = 'organization',
  intersection = 'organization',
  locality = 'city',
  natural_feature = 'city',
  neighborhood = 'distrcict',
  place_of_worship = 'attractions',
  political = 'organization',
  point_of_interest = 'attractions',
  post_box = 'organization',
  postal_code = 'organization',
  postal_code_prefix = 'distrcict',
  postal_code_suffix = 'distrcict',
  postal_town = 'distrcict',
  premise = 'attractions',
  room = 'hotel',
  route = 'distrcict',
  street_address = 'distrcict',
  street_number = 'distrcict',
  sublocality = 'distrcict',
  sublocality_level_4 = 'distrcict',
  sublocality_level_5 = 'distrcict',
  sublocality_level_3 = 'distrcict',
  sublocality_level_2 = 'distrcict',
  sublocality_level_1 = 'distrcict',
  university = 'distrcict',
  subpremise = 'organization',
}
